// An agent waking itself up (its schedule, a wake it set, a trigger, a board message, a manual
// run) runs as a turn in its own chat. That turn's text starts with a wake header —
// `<marker><kind>\n<why it woke>` — which the agent window draws as a "woke up" divider instead
// of a bubble from you. Kept in sync with AGENT_WAKE_MARKER in the server's agentRun.ts.
import { visibleMessageText } from "../voice/useVoiceConversation";

export const AGENT_WAKE_MARKER = "===MORROW_AGENT_WAKE===";

export type AgentWakeKind = "schedule" | "self-wake" | "pursue" | "trigger" | "board" | "manual";

export interface AgentWake {
  readonly kind: AgentWakeKind | "other";
  readonly reason: string;
}

const KINDS: ReadonlyArray<AgentWakeKind> = [
  "schedule",
  "self-wake",
  "pursue",
  "trigger",
  "board",
  "manual",
];

/** The wake behind a message, or null when it's an ordinary message. */
export function parseAgentWake(text: string): AgentWake | null {
  if (!text.startsWith(AGENT_WAKE_MARKER)) return null;
  const header = visibleMessageText(text).slice(AGENT_WAKE_MARKER.length);
  const nl = header.indexOf("\n");
  const kind = (nl === -1 ? header : header.slice(0, nl)).trim();
  const reason = nl === -1 ? "" : header.slice(nl + 1).trim();
  return {
    kind: (KINDS as ReadonlyArray<string>).includes(kind) ? (kind as AgentWakeKind) : "other",
    reason,
  };
}
